module.exports = __webpack_public_path__ + "static/media/angelaicon.b5af491f.svg";